export default "__VITE_ASSET__DCgtRBFt__"